/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter,
} from 'react-router-dom';
import { connect } from 'react-redux';
import LoggedOutComponent from 'routes/User/LoggedOut/LoggedOutPage';
import { isAdmin } from 'services/adminCheck';

class AuthRoute extends React.Component {
  render() {
    const { user, component: Component, logoutMessage, ...rest } = this.props;

    console.log('In auth route and pathname is...');
    console.log(this.props.location.pathname);
    console.log('user is...');
    console.log(user);

    if (user.isWaiting) return <div>Loading...</div>;

    // alert("prop.location is..."+JSON.stringify(this.props.location));

    if (logoutMessage && !user.authenticated) {
      return (
        <h2
          className="d-flex justify-content-center font-weight-bold"
          style={{ height: 'calc(100% - 70px)', marginTop: '200px' }}
        >
          {logoutMessage}
        </h2>
      );
    }

    const nextState = {
      ...this.props.location.state,
      // onClose: this.props.onClose
    };

    // const conditionalHomePage =
    //   parseInt(Math.random() * 2) === 0 ? '/home/news' : '/home/readers';
    const conditionalHomePage = '/home/intro';

    const redirectPage = isAdmin ? '/login' : conditionalHomePage;

    if (!user.authenticated) {
      return (
        <Route
          {...rest}
          render={(props) => (
            <Redirect
              to={{
                pathname: this.props.location.pathname.startsWith('/popup')
                  ? '/auth/signUp'
                  : redirectPage,
                state: {
                  nextPathname: this.props.location.pathname,
                  nextSearch: this.props.location.search,
                  nextState,
                },
              }}
            />
            // <LoggedOutComponent />
          )}
        />
      );
    }

    if (
      !user.user.profile.surveyResponse ||
      !user.user.profile.surveyResponse.isComplete ||
      user.user.profile.gettingStartedStatus !== 'finished'
    ) {
      if (this.props.location.pathname !== '/welcome') {
        return (
          <Route
            {...rest}
            render={(props) => (
              <Redirect
                to={{
                  pathname: `/welcome`,
                  state: {
                    nextPathname: this.props.location.pathname,
                    nextSearch: this.props.location.search,
                    nextState,
                  },
                }}
              />
            )}
          />
        );
      }
    } else {
      if (
        this.props.location.pathname !== '/test-cohort' &&
        user.user.testCohort === 'Wisconsin-Control'
      ) {
        return (
          <Route
            {...rest}
            render={(props) => (
              <Redirect
                to={{
                  pathname: `/test-cohort`,
                }}
              />
            )}
          />
        );
      }
    }

    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }
}

export default connect((state) => ({
  user: state.user,
}))(AuthRoute);
